import React from 'react';
import { View, Text } from 'react-native';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '@shared/components/md-design-system/Layout/LoadingSpinner';

interface IChatConnectingStateProps {
    message?: string;
}

export const ChatConnectingState: React.FC<IChatConnectingStateProps> = ({
    message
}) => {
    const { t } = useTranslation();

    return (
        <View className="flex-1 justify-center items-center px-8">
            <LoadingSpinner size="large" color="primary" />
            <Text className="font-medium text-base mt-8">
                {message || t('commons.connection.connecting')}
            </Text>
        </View>
    );
};
